import React from 'react';

/* Symbols */
import ArrowDownIcon from '~/../symbols/arrow-down.svg';
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Icon, Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

/* Icons */
import ResetIcon from '~/../symbols/reset.svg';

export default function FilterCollapse({ filterKey, children, title, isOpen, onToggle, activeCount, resetFilter, gradient, colorView }) {
    return (
        <div className={`collapse-item ${ isOpen ? 'collapse-show' : '' }`}>
            <button
                onClick={onToggle}
                className={`filter-toggle justify-content-between btn-block text--16 ${ activeCount != null && activeCount !== 0 ? 'has-items-selected' : '' }`}
                aria-expanded={isOpen}
            >
                <span className="btn__text">
                    <span className="text">{title}</span>
                    {activeCount != null && activeCount !== 0 && (
                        <span className="active-count">{activeCount}</span>
                    )}
                    <div className="btn__icon ml-auto ml-lg-0">
                        <Icon url={ArrowDownIcon.url} size={24} className={isOpen ? 'icon--open' : 'icon--closed'} />
                    </div>
                </span>
            </button>
            <div className={`collapse-content ${ isOpen ? 'show' : 'hide' }`}>
                <div className={`collapse__outer ${colorView ? 'collapse__outer--color-view' : ''} ${ gradient ? 'pb-0' : '' }`}>
                    <div className="d-flex d-lg-none align-items-center justify-content-between mb-4">
                        <span className="text--sm font-weight-bold">{title}</span>
                        <div onClick={onToggle}>
                            <Icon url={CrossIcon.url} size={12} className={'icon--lg-16 cursor-pointer'} />
                        </div>
                    </div>
                    <div className="collapse__wrapper">
                        <div className="collapse__scroll-container">
                            {children}
                        </div>
                    </div>
                </div>
                <div className="collapse__footer">
                    <Button
                        className="btn-reset gap-2 d-flex text--14 justify-content-center align-items-center font-weight-bold"
                        theme="none"
                        title={trans('app.vacancy_overview.reset')}
                        onClick={() => resetFilter(filterKey)}
                        showIcon={true}
                        icon={ResetIcon}
                        iconSize={24}
                    />
                    <Button
                        title={trans('app.vacancy_overview.save')}
                        className="text--14"
                        theme="primary"
                        onClick={onToggle}
                    />
                </div>
            </div>
        </div>
    );
}
